import { assign, template } from 'lodash';
import React, { useMemo } from 'react';
import { Text } from 'vkit/lib/components';

interface CountCharMessageProps {
  value?: string | null;
  limit?: number;
  // use a sintax do lodash template para customizar as mensagens
  // https://lodash.com/docs/4.17.15#template
  templateMessage?: {
    manyRemaining?: string;
    oneRemaining?: string;
    amountAchieved?: string;
    exceededLimit?: string;
  };
}

export const CountCharMessage: React.FC<CountCharMessageProps> = ({
  value,
  limit = 0,
  templateMessage,
}) => {
  const messages = useMemo(() => {
    return assign(
      {
        amountAchieved: 'Limite de <%= limit %> caracteres atingido',
        manyRemaining: '<%= remaining %> caracteres restantes',
        oneRemaining: '1 caractere restante',
        exceededLimit: 'Limite de <%= limit %> caracteres excedido',
      },
      templateMessage,
    );
  }, [templateMessage]);

  const remainingCharMessage = useMemo(() => {
    const remaining = limit - (value?.length || 0);

    let messageTemplate;
    if (remaining === 0) {
      messageTemplate = messages.amountAchieved;
    } else if (remaining > 1) {
      messageTemplate = messages.manyRemaining;
    } else if (remaining < 0) {
      messageTemplate = messages.exceededLimit;
    } else {
      messageTemplate = messages.oneRemaining;
    }

    return template(messageTemplate)({ limit, remaining });
  }, [
    limit,
    messages.amountAchieved,
    messages.exceededLimit,
    messages.manyRemaining,
    messages.oneRemaining,
    value?.length,
  ]);

  return <Text size='medium' value={remainingCharMessage} />;
};
